import { UserDetails } from "@src/BookingTools/App/AppDataProvider/AppDataProvider";

export function parsePrefillData(): Partial<UserDetails> {
  const urlParams = new URLSearchParams(window.location.search);

  const firstName = urlParams.get("customerPrefill[firstname]");
  const lastName = urlParams.get("customerPrefill[lastname]");
  const email = urlParams.get("customerPrefill[email]");
  const phone = urlParams.get("customerPrefill[mobile]");

  const customFields = new Map<string, string>();
  urlParams.forEach((value, key) => {
    if (key.includes("customerPrefill[customFields]")) {
      const match = key.match(/customerPrefill\[customFields\]\[(.*?)\]/);
      if (match && match[1]) {
        customFields.set(match[1], value);
      }
    }
  });

  return {
    ...(firstName && { firstName }),
    ...(lastName && { lastName }),
    ...(email && { email }),
    ...(phone && { phone }),
    ...(customFields.size > 0 && {
      crmFieldData: Object.fromEntries(customFields.entries()),
    }),
  };
}
